/* eslint-disable @typescript-eslint/consistent-type-imports */
import { ChangeDetectorRef, Component, EventEmitter, HostListener, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { NotificationService } from '../../notification/_services/notification.service';
import { ActivatedRouteSnapshot, NavigationEnd, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { filter, Observable, startWith, Subscription } from 'rxjs';
import { environment } from '../../../environments/environment';
import { AIAgentService } from '../../../libraries/e3duiplatform-eva-mfe/libs/eva/src/lib/ai-agent/services/ai-agent.service';
import { ENVIRONMENTS, USERROLES } from '../../app.config';
import { AppEnvConfig } from '../../app.env.config';
import { LocalCacheService } from '../../core/local-cache/local-cache.service';
import { UserService } from '../../core/user/user.service';
import { SelectedMenus } from '../../menu/contracts/menu';
import { MenuService } from '../../menu/menu.service';
import { headerHandlerService } from './../../core/nav/header-handler.service';
import { SubheaderHandlerService } from './../../core/nav/subheader-handler.service';
import { ISubheaderLeftSection } from './../../shared-main/components/sub-header/sub-header.modal';
import { User, UserSettings } from './../../shared-main/models/User';
import { DividerOption } from './../divider/divider.model';

@Component({
  selector: 'nalco-app-header',
  templateUrl: './app-header.component.html',
  standalone: false
})
export class AppHeaderComponent implements OnInit, OnDestroy {
  @Input() user: User; // Defines the user Authentication
  @Input() hideSubHeader?: boolean = false;
  @Input() isHomePage?: boolean = false;
  @Output() subHeaderHiddenChange = new EventEmitter<boolean>();
  userInfo: User;
  pageTitle = '';
  profileDdToggle = false;
  Initials = '';
  collapsed = true;
  isFbiRoute: boolean;
  isFsqsUser: boolean;
  toggleCollapsed(): void {
    this.collapsed = !this.collapsed;
  }
  isSubHeaderHidden: boolean = false;
  shouldHideSubHeader: boolean;
  dividerCss: DividerOption;
  leftSection: ISubheaderLeftSection; // Getting page information from the existing sub header service
  isExpand = false;
  isMobile = false;
  isMobileLayoutRoute = false;
  private readonly mobileBreakpoint = 720;
  showDropdownMenu: boolean;
  showThreeDotOptions: boolean;
  isNewUIEnabled: boolean;
  showNotification: boolean;
  @Output() showLoader: EventEmitter<boolean> = new EventEmitter();
  private subscriptions: Subscription[] = [];

  showMobileMenu: boolean = false;
  showMobileNotifications: boolean = false;
  mobileNotifications: any[] = [];

  showCloudInstanceNavigation: boolean = false;
  azure = 'azure';
  aws = 'aws';
  enableAIAgent = false;
  isFnbIntelligenceUser = false;
  isFbiOnboardingRoute = false;
  isWaterIntelligenceRoute = false;
  isWaterIntelligenceLandingRoute = false;
  isLegionellaDashboardRoute = false;
  isFsqsRoute = false;

  constructor(private headerService: headerHandlerService,
    private translate: TranslateService,
    private cache: LocalCacheService,
    private subHeaderService: SubheaderHandlerService,
    private router: Router,
    private menuService: MenuService,
    private config: AppEnvConfig,
    private userService: UserService,
    private changeDetectionRef: ChangeDetectorRef,
    private aiAgentService: AIAgentService,
    private notificationService: NotificationService
  ) {
  }

  /**
  * @description This hostlistner function is used to display and hide the user profile according to the user selection
  * @param event to catch the instance to get the class name 
  */

  @HostListener('document:click', ['$event']) clickedProfile(event: { target: { className: string; }; }) {
    if ((event.target.className.indexOf !== undefined
      && event.target.className === 'custom-dropdown-img')) {
      this.showDropdown();
    } else if (this.isMobile && event.target.className === 'span-round') {
      this.showDropdownMenu = true;
    }
    else {
      if (this.showDropdownMenu) {
        this.showDropdownMenu = !this.showDropdownMenu;
      }
    }
    if (event.target.className.indexOf !== undefined && this.isMobile
      && (event.target.className.indexOf('submenu-margin') > 0 ||
        event.target.className.indexOf('singlemenu') > -1)) {
      this.isExpand = false;
      this.showMobileMenu = false;
      this.showMobileNotifications = false;
    }
  }

  /**
   * @description Routes where the narrow-window (< 720px) mobile layout is enabled:
   * the DCI routes plus /home. Other routes keep the desktop layout on narrow windows.
   */
  private isMobileScopedRoute(): boolean {
    const url = this.router.url;
    return url.startsWith('/legionella-test-results')
      || url.startsWith('/upload-reports-and-plans')
      || url.startsWith('/coolant-health-iq')
      || url.startsWith('/home');
  }

  /**
   * @description Recomputes the mobile state from device user-agent (all routes) OR viewport
   * width (< 720px, scoped routes only) so the narrow-window mobile layout is route-scoped.
   */
  private checkIsMobile(): void {
    const isMobileDevice = (/android|webos|iphone|ipad|ipod|blackberry|windows phone/).test(navigator.userAgent.toLowerCase());
    this.isMobileLayoutRoute = this.isMobileScopedRoute();
    this.isMobile = isMobileDevice || (this.isMobileLayoutRoute && window.innerWidth < this.mobileBreakpoint);
  }

  @HostListener('window:resize') onResize(): void {
    this.checkIsMobile();
  }

  ngOnInit() {
    this.checkIsMobile();
    let initial = '';
    this.userInfo = JSON.parse(this.cache.fetchData('msalUserInfo'));
    this.isNewUIEnabled = JSON.parse(this.config.getEnv('isNewUIEnabled').toString())
    const givenName = this.checkUserName(this.userInfo.userPrincipalName || this.userInfo.EmailAddress);
    if (givenName) {
      initial = givenName.substring(0, 1);
    }
    if (this.userInfo.surname || this.userInfo.LastName) {
      const surname = this.userInfo.surname || this.userInfo.LastName;
      if (surname) {
        initial += surname.substring(0, 1);
      } else {
        // fallback to get from given_name, if family name is null
        const firstName = this.userInfo.FirstName || this.userInfo.displayName;
        initial += firstName.split(' ')[1].substring(0, 1);
      }
    }
    this.Initials = initial.toUpperCase();
    // For the divider Css
    this.dividerCss = {
      color: "#bac7d8",
      minLength: '25px',
      isHorizontal: false
    }
    // to get exisiting isExpand value
    this.menuService.navExpand.subscribe(value =>
      this.isExpand = value
    )
    this.subHeaderService.subheaderData$.subscribe((data) => {
      this.isSubHeaderHidden = data;
      this.shouldHideSubHeader = this.hideSubHeader && this.isSubHeaderHidden;
      this.shouldHideSubHeader = this.shouldHideSubHeader === undefined ? false : this.shouldHideSubHeader;
      this.subHeaderHiddenChange.emit(this.shouldHideSubHeader);
    });
    this.getPagetTitle();
    this.setPageTitleFromRoute();
    this.hideUnreadNotification();
    const settings = this.userService.getCurrentSettings();
    const isEnvEnabled = settings?.IsInternalUser && environment.environment === ENVIRONMENTS.Dev;
    const hasFBIAccess = this.getUserPermission(settings, [USERROLES.FBI_DASHBOARD]);
    const hasFbiEvaReadAccess = this.getUserPermission(settings, [USERROLES.FBI_EVA_READ]);
    const hasFSQSWritePermission = this.getUserPermission(settings, [USERROLES.FSQS_PROCEDURE_WRITE]);
    this.subscriptions.push(
      this.router.events.pipe(filter(e => e instanceof NavigationEnd), startWith(null))
        .subscribe(() => {
          this.isFbiRoute = this.router.url.includes('food-and-beverage-intelligence');
          this.isFbiOnboardingRoute = this.router.url.startsWith('/food-and-beverage-intelligence/onboarding')
            || this.router.url.startsWith('/food-and-beverage-intelligence/opportunities');
          this.isWaterIntelligenceRoute = /^\/water(\/|$|\?)/.test(this.router.url);
          this.isWaterIntelligenceLandingRoute = /^\/water(\/|$|\?)/.test(this.router.url);
          this.isLegionellaDashboardRoute = this.router.url.includes('/legionella-test-results');
          this.isFsqsRoute = this.router.url.includes('food-safety-iq');
          this.checkIsMobile();
          this.setPageTitleFromRoute();
          this.enableAIAgent = isEnvEnabled || (hasFBIAccess && hasFbiEvaReadAccess && this.isFbiRoute) || (hasFSQSWritePermission && this.isFsqsRoute);
          this.isFnbIntelligenceUser = hasFBIAccess && this.isFbiRoute;
          this.isFsqsUser = hasFSQSWritePermission && this.isFsqsRoute;

        })
    );
  }

  openEVA() {
    if (this.isFbiRoute || this.isWaterIntelligenceLandingRoute) {
      this.aiAgentService.setEvaState({ show: true, collapsed: false });
      return;
    }
  }

  /**
   * @description This function is to get the page title from existing sub header module service 
   */

  getPagetTitle(): void {
    this.subscriptions.push(this.subHeaderService.subheaderLeftSection$.subscribe(async (update) => {
      this.leftSection = await update;
      if (this.leftSection.data && this.leftSection.data[0] && this.leftSection.data[0].text) {
        if (this.leftSection.serviceType === 'paper') {
          this.pageTitle = this.translate.instant("PAPER.TITLE");
        }
        else {
          this.pageTitle = this.leftSection.data[0].text
        }
      } else {
        this.pageTitle = this.leftSection.data || this.getRouteBreadcrumbTitle() || this.translate.instant("LEFT_NAV.HOME_NAV_LABEL");
      }
      this.pageTitle = (typeof this.pageTitle === 'string') ? this.pageTitle : '';
      this.changeDetectionRef.detectChanges();
    }));
  }

  private getRouteBreadcrumbTitle(): string {
    if (!this.isFbiOnboardingRoute) return null;
    const root = this.router.routerState.snapshot.root;
    const stack: ActivatedRouteSnapshot[] = [root];
    let breadcrumb = '';

    while (stack.length) {
      const current = stack.pop();
      if (!current) {
        continue;
      }

      const routeBreadcrumb = current.data?.['breadcrumb'];
      if (typeof routeBreadcrumb === 'string' && routeBreadcrumb.trim().length > 0) {
        breadcrumb = routeBreadcrumb;
      }

      for (const child of current.children) {
        stack.push(child);
      }
    }

    return breadcrumb;
  }

  private setPageTitleFromRoute(): void {
    if (this.isFbiOnboardingRoute) {
      this.pageTitle = 'Food and Beverage Intelligence';
      return;
    }

    const breadcrumb = this.getRouteBreadcrumbTitle();
    if (breadcrumb) {
      this.pageTitle = breadcrumb;
    }
  }

  /**
   * Hides the unread notification API call based on the current PDF generation mode.
   * If the application is in SSD Schedule PDF Generation mode, the notification is hidden.
   * Otherwise, the notification remains visible.
   */
  public hideUnreadNotification(): void {
    const returnUrl = this.cache.fetchData('returnUrl');
    this.showNotification = !(returnUrl?.includes('pdfGeneration=true'));
  }



  /**
   * @description It Will expand the left navigation bar 
   * Passing values with the help of behaviour subject
   */
  expandNavBar(): void {
    this.isExpand = !this.isExpand;
    this.menuService.navExpand.next(this.isExpand);
    this.showThreeDotOptions = false;
  }

  /**
  * @description used to close the left navigation bar on click of close icon.
  */
  onCloseNavBar(): void {
    this.isExpand = !this.isExpand;
    this.menuService.navExpand.next(this.isExpand);
    this.showThreeDotOptions = false;
  }

  /**
   * @description Hide & Show DropDownMenu
   */

  showDropdown(): void {
    this.showDropdownMenu = !this.showDropdownMenu;
  }

  /**
  * @description used to show the logout dropdown on click.
  */
  showDropdownForLogout(): void {
    if (this.isMobile) {
      this.showDropdownMenu = !this.showDropdownMenu;
    }
  }

  logout() {
    document.cookie = "host=; path=/;Secure";
    document.cookie = 'manualredirection=; path=/;Secure';
    this.router.navigate(['/logout']);
  }

  clickBtn() {
    this.headerService.btnclickhead$(event);
    this.router.navigate(['/home']);
    this.showThreeDotOptions = false;
  }

  showProfileSubMenu() {
    this.profileDdToggle = !this.profileDdToggle;
  }

  // Checking given_name is undefined
  checkUserName(name) {
    if (name !== undefined) {
      return name;
    } else {
      return this.userInfo.FirstName;
    }
  }

  /**
  * @description used to show the Profile and Notifications dropdown on three dot click.
  */
  showThreeDotOptionsMenu(): void {
    if (this.isMobile) {
      this.showThreeDotOptions = !this.showThreeDotOptions;
    }
  }

  handleLoading(loader: boolean) {
    this.showLoader.emit(loader);
  }

  toggleMobileMenu(): void {
    this.showMobileMenu = !this.showMobileMenu;
    if (!this.showMobileMenu) {
      this.showMobileNotifications = false;
      this.showMobileNotificationAccordion = false;
    } else {
      this.loadMobileNotifications();
    }
  }

  loadMobileNotifications(): void {
    this.subscriptions.push(
      this.notificationService.getAllUnreadNotifications().subscribe(res => {
        this.mobileNotifications = res || [];
        this.changeDetectionRef.markForCheck();
      })
    );
  }

  openMobileNotifications(): void {
    this.showMobileNotifications = true;
  }

  closeMobileNotifications(): void {
    this.showMobileNotifications = false;
  }

  showMobileNotificationAccordion: boolean = false;

  getMobileNotificationDetails(notification: any): { title: string, message: string } {
    const replicateKey = this.translate.instant('ASSET_HARVESTER.REPLICATE_MOVE_NOTIFICATION');
    const title = notification.NotificationCategoryTypeId === replicateKey
      ? this.translate.instant('ASSET_HARVESTER.MESSAGE.REPLICATE_OR_MOVE_MEASUREMENTS')
      : notification.Title;
    const message = notification.NotificationCategoryTypeId === replicateKey
      ? notification.Title
      : this.translate.instant('NOTIFICATIONS.NOTIFICATION_MESSAGE');
    return { title, message };
  }

  toggleMobileNotificationAccordion(): void {
    this.showMobileNotificationAccordion = !this.showMobileNotificationAccordion;
  }

  onMobileNotificationClick(notification: any): void {
    this.showMobileMenu = false;
    this.showMobileNotifications = false;
    this.notificationService.setNotificationCategory(notification.NotificationCategoryTypeId);
    const dataContinuityKey = this.translate.instant('ASSET_HARVESTER.DATA_CONTINUITY_NOTIFICATION');
    if (notification.NotificationCategoryTypeId === dataContinuityKey) {
      this.router.navigate(['/merge-system-name',
        notification.Title, notification.PartitionKey,
        notification.NotificationProperties.OldDatasourceCpId,
        notification.NotificationProperties.NewDatasourceCpId,
        notification.NotificationProperties.SiteId]);
    }
  }


  /**
 * Determines if the given user has a specific permission.
 *
 * @private
 * @function getUserPermission
 * @param {UserSettings} user - The current user’s settings object.
 * @param {string[]} permissionIds - The permission IDs to check against.
 * @returns {boolean} True if the user has the permission, otherwise false.
 */
  private getUserPermission(user: UserSettings, permissionIds: string[]): boolean {
    return user.Permissions.some((p) => permissionIds.includes(p.PermissionId.toString()));
  }


  /**
  * @description this lifecycle is used unsubscribe the subscribed api calls and observables
  */

  ngOnDestroy() {
    this.menuService.navExpand.unsubscribe();
  }
}
